import { render } from "./Poc.vue?vue&type=template&id=7ff81e73"
import script from "./Poc.vue?vue&type=script&lang=js"
export * from "./Poc.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__